import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { useStores } from '../hooks/use-stores';

const PrivateRoute = ({ children, notLoggedUrl }) => {
    const location = useLocation();
    const { authStore } = useStores();

    const isLoggedIn = authStore.isAuthenticated === true && authStore.token != null;

    const fallback =
        notLoggedUrl ||
        `/auth/signin?redirect=${encodeURIComponent(`${location.pathname}${location.search}`)}`;

    return isLoggedIn ? <>{children}</> : <Navigate replace to={fallback} />;
};

export default observer(PrivateRoute);
